<template>
  <el-drawer v-model="val" custom-class="pro-drawer" size="30%" :close-on-click-modal="false" destroy-on-close>
    <template #title>
      <h4>{{ title }}</h4>
    </template>
    <el-form ref="proAddOrEditFormRef" label-position="right" label-width="110px" :model="proAddOrEditForm" :rules="rules">
      <el-form-item label="施工队名称:" prop="teamName">
        <el-input v-model="proAddOrEditForm.teamName"></el-input>
      </el-form-item>
      <el-form-item label="所属单位名称:" prop="teamOrgName">
        <el-input v-model="proAddOrEditForm.teamOrgName"></el-input>
      </el-form-item>
      <el-form-item label="现场负责人:">
        <el-select v-model="proAddOrEditForm.siteLeaderId" clearable @change="siteLeaderChange">
          <el-option v-for="u of users" :key="u.id" :value="u.id" :label="u.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人电话:" prop="siteLeaderPhone">
        <el-input v-model="proAddOrEditForm.siteLeaderPhone" disabled></el-input>
      </el-form-item>
      <el-form-item label="施工队介绍:">
        <el-input v-model="proAddOrEditForm.electronicFence" :rows="3" type="textarea" placeholder="施工队介绍" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="val = false">取消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </div>
    </template>
  </el-drawer>
</template>
<script>
import { defineComponent } from "vue";
import { getProjectDirectUser, saveProject } from "@/api/proman/project";
import { ElMessage } from "element-plus";
import { deepClone } from "@/utils/common";
export default defineComponent({
  emits: ["update:modelValue", "scarch"],
  data() {
    return {
      users: [],
      proAddOrEditForm: {},
      rules: {
        teamName: [
          { required: true, message: "请输入施工队名称", trigger: "change" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "change" }
        ],
        teamOrgName: [{required: true, message: '请输入施工队所属单位名称'}]
      },
    };
  },
  props: {
    modelValue: Boolean,
    title: String,
    teamListRowData: Object,
    addTeamListRowData: Object,
  },
  watch: {
    val(value) {
      if (!value) {
        return;
      }
      this.users = [];
      if (this.teamListRowData) {
        this.proAddOrEditForm = deepClone(this.teamListRowData);
        this.getUsers(this.teamListRowData.id);
      } else {
        this.typeOfWorks = [];
        let obj = this.addTeamListRowData;
        this.proAddOrEditForm = {
          projectId: obj.id,
          projectName: obj.projectName,
          projectNum: obj.projectNum,
          type: "TEAM",
        };
      }
    },
  },
  computed: {
    val: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    userObj() {
      let ret = {};
      this.users.forEach(u => ret[u.id] = u);
      return ret;
    }
  },
  mounted() {},
  methods: {
    save() {
      this.$refs.proAddOrEditFormRef.validate((valid) => {
        if (valid) {
          saveProject(this.proAddOrEditForm).then(({ data }) => {
            if (data && data.status === true) {
              ElMessage({
                message: "保存成功",
                type: "success",
              });
              this.val = false;
              this.$emit("scarch");
            } else {
              ElMessage({
                message: data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
    //项目状态选择改变
    statusChange(val) {
      if (val) {
        if (val === 0) {
          this.statusName = "未完工";
        } else {
          this.statusName = "已完工";
        }
      }
    },
    getUsers(teamId) {
      getProjectDirectUser({ teamId }).then(({ data }) => {
        this.users = data.data;
      });
    },
    // 负责人改变事件
    siteLeaderChange(userId) {
      let user = this.userObj[userId] || {};
      this.proAddOrEditForm.siteLeaderName = user.name;
      this.proAddOrEditForm.siteLeaderPhone = user.phone;
    }
  },
});
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" >
.pro-drawer {
  .el-drawer__header {
    padding: 0px 10px 0px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
</style>